<template>
  <div>
    <ContentHeader title="Manager Cabang" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-primary">
              <form @submit.prevent="handleCreateData()" class="card-body">
                <div
                  v-if="user.name == '' || user.pic == '' || user.phone == ''"
                  class="alert alert-danger"
                  role="alert"
                >
                  Please update profile first.
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="company_name">Company Name</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{
                          'border-danger': $v.payload.company_name.$error,
                        }"
                        id="company_name"
                        placeholder="Enter Company Name"
                        v-model="payload.company_name"
                      />
                      <div
                        class="text-danger"
                        v-if="$v.payload.company_name.$error"
                      >
                        <small>Company Name Required</small>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="pic">PIC</label>
                      <input
                        type="text"
                        class="form-control"
                        id="pic"
                        :class="{
                          'border-danger': $v.payload.pic.$error,
                        }"
                        placeholder="Enter PIC number"
                        v-model="payload.pic"
                      />
                      <div class="text-danger" v-if="$v.payload.pic.$error">
                        <small>PIC Required</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="email">Email</label>
                      <input
                        type="email"
                        class="form-control"
                        id="email"
                        placeholder="Enter Email"
                        :class="{
                          'border-danger': $v.payload.email.$error,
                        }"
                        v-model="payload.email"
                        disabled
                      />
                    </div>
                    <div class="text-danger" v-if="$v.payload.email.$error">
                      <small>Email Required</small>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="phone">Phone</label>
                      <vue-tel-input
                        v-model="payload.phone"
                        :autoDefaultCountry="false"
                        @validate="validatePhone"
                        @country-changed="countryChanged"
                        @input="validateFirstLetter"
                        :class="{
                          'border-danger':
                            !phoneValid || !$v.payload.phone.required || !$v.payload.phone.checkData,
                        }"
                      ></vue-tel-input>
                      <div class="text-danger" v-if="!$v.payload.phone.required">
                        <small>Phone Required</small>
                      </div>
                      <div class="text-danger" v-if="!phoneValid || !$v.payload.phone.checkData">
                        <small>Phone Number is invalid</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="address">Address</label>
                      <input
                        type="text"
                        class="form-control"
                        id="address"
                        placeholder="Enter Address"
                        v-model="payload.address"
                        :class="{ 'border-danger': $v.payload.address.$error }"
                      />
                      <div class="text-danger" v-if="$v.payload.address.$error">
                        <small>Address Required</small>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- <div class="mb-3">
                    <label for="country" class="form-label">Country</label>
                    <country-select
                      class="form-control"
                      v-model="payload.country"
                      :country="payload.country"
                      :class="{ 'border-danger': $v.payload.country.$error }"
                      :countryName="true"
                      topCountry="ID"
                    />
                    <div class="text-danger" v-if="$v.payload.country.$error">
                      <small v-if="!$v.payload.country.required"
                        >Country is Required</small
                      >
                    </div>
                  </div> -->
                    <div class="form-group">
                      <label for="country" class="form-label">Country</label>
                      <country-select
                        class="form-control"
                        v-model="payload.country"
                        :country="payload.country"
                        :class="{ 'border-danger': $v.payload.country.$error }"
                        :countryName="true"
                        topCountry="ID"
                      />
                      <div class="text-danger" v-if="$v.payload.country.$error">
                        <small>Country Required</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label for="legal_doc">Document Legal</label>
                      <div class="input-group">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="form-control"
                            id="fileInput"
                            placeholder="Enter Document Legal"
                            @change="handleFileUpload($event)"
                          />
                          <label style="z-index: 0;" class="custom-file-label" for="fileInput">{{
                            legal_doc_label
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <button
                    type="submit"
                    href="#"
                    class="btn btn-danger btn-block rounded-pill"
                  >
                    Update Profile
                  </button>
                </div>
                <div class="card-footer">
                  <router-link to="/profile" class="btn btn-outline-danger btn-block rounded-pill">
                    Cancel
                  </router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiClient from "../../services/ApiServices";
import { required, helpers } from "vuelidate/lib/validators";

const checkData = helpers.regex('checkData', /^[0-9+ ]+$/)

export default {
  components: {
    ContentHeader,
  },
  validations: {
    payload: {
      company_name: {
        required,
      },
      email: {
        required,
      },
      pic: {
        required,
      },
      address: {
        required,
      },
      phone: {
        required,
        checkData,
      },
      country: {
        required,
      },
    },
  },
  created() {
    document.title = "Update Profile - Manager Cabang";
  },
  data() {
    return {
      payload: {
        // username: "",
        company_name: "",
        email: "",
        pic: "",
        address: "",
        phone: "",
        country: "",
        legal_doc: "",
      },
      phoneFirstTimeLoad: 0,
      phoneValid: "",
      legal_doc_label: "Choose File",
      isDisabled: false,
    };
  },
  async mounted() {
    await apiClient
      .get(`/${this.$user_id}/`)
      .then((response) => {
        const legalDoc = response.data.data.legal_doc;
        let phoneCode = "";
        this.payload = response.data.data;
        this.payload.legal_doc = "";
        if (legalDoc) {
          this.legal_doc_label = legalDoc.substring(
            legalDoc.lastIndexOf("/") + 1
          );
        } else {
          this.legal_doc_label = "Choose File";
        }
        phoneCode = response.data.data.phone.substring(0, 3);
        if (phoneCode == "+93") {
          this.phoneFirstTimeLoad++;
        }
      })
      .catch((error) => {
        if (error.status == 401) {
          this.$swal("Opps..", error.statusText.toUpperCase(), "error").then(
            () => {
              this.$store.dispatch("logout");
            }
          );
        }
      });
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    countryChanged(country) {
      this.phoneFirstTimeLoad++;
      let countryCode = country.dialCode;

      if (this.phoneFirstTimeLoad > 2) {
        const myPromise = new Promise((resolve) => {
          resolve((this.payload.phone = ""));
        });

        myPromise.then(() => {
          this.payload.phone = `+${countryCode}`;
        });
      }
    },
    validatePhone(country) {
      this.phoneValid = country.valid;
    },
    validateFirstLetter() {
      if (this.payload.phone[0] != "+") {
        this.phoneValid = false;
      }
    },
    handleFileUpload(event) {
      this.payload.legal_doc = event.target.files[0];

      if (this.payload.legal_doc == null) {
        this.legal_doc_label = "Choose File";
      }
      this.legal_doc_label = event.target.files[0].name;
    },

    handleCreateData() {
      let data = new FormData();
      this.isDisabled = true;
      console.log(this.phoneValid);
      // data.append("username", this.payload.username);
      data.append("company_name", this.payload.company_name);
      data.append("email", this.payload.email);
      data.append("pic", this.payload.pic);
      data.append("address", this.payload.address);
      data.append("phone", this.payload.phone);
      data.append("country", this.payload.country);
      if (this.payload.legal_doc != "") {
        data.append("legal_doc", this.payload.legal_doc);
      }

      this.$v.$touch();
      if (this.phoneValid && !this.$v.$invalid) {
        apiClient
          .put(`/${this.$route.params.id}/`, data)
          .then(() => {
            this.$swal("Updated!", "Profile Has Been Updated.", "success").then(
              () => {
                this.$router.push({ name: "Profile" });
              }
            );
            this.isDisabled = false;
          })
          .catch((error) => {
            this.$toasted.show(error.message, {
              theme: "toasted-primary",
              position: "top-right",
              duration: 4000,
            });
            if (error.response.data.status == 401) {
              this.$swal(
                "Opps..",
                error.response.data.message.toUpperCase(),
                "error"
              ).then(() => {
                this.$store.dispatch("logout");
              });
            }
            this.isDisabled = false;
          });
      } else {
        this.isDisabled = false;
      }
    },
  },
};
</script>

<style>
@import "../../../public/custom_styles/profile.css";
</style>